// extracted by mini-css-extract-plugin
export default {"dialog":"delete-categories-modal_dialog__FXfiN","action-wrapper":"delete-categories-modal_action-wrapper__T69JR","confirm":"delete-categories-modal_confirm__1K6Sg"};